// extracted by mini-css-extract-plugin
module.exports =  {"stopBuild":"StopBuild__stopBuild--PY","iconOnly":"StopBuild__iconOnly--DQ","invisible":"StopBuild__invisible--bg"};